module.exports = __webpack_public_path__ + "img/homepage_0@2x.4e3f33e9.jpg";